import "./Services.module.css";
import Nagłówek from "@/reusable_sections/Header";
import CustomCleaningSection from "./sections/CustomCleaningSection";
import SzybkieTerminyRealizacji from "./sections/SzybkieTerminyRealizacji";
import PlumbingAssortment from "./sections/PlumbingAssortment";
import Profile from "./sections/Profile";
import TrainerFooter from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Nagłówek />
      <CustomCleaningSection />
      <PlumbingAssortment />
      <SzybkieTerminyRealizacji />
      <Profile />
      <TrainerFooter />
    </div>;
}